// ===================== Math helpers =====================
export const TAU = Math.PI * 2;
export const HALF_PI = Math.PI / 2;

export const clamp = (v, lo, hi) => (v < lo ? lo : v > hi ? hi : v);
export const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
export const lerp = (a, b, t) => a + (b - a) * t;
export const sign = Math.sign;

export function dist2(ax, ay, bx, by) {
  const dx = bx - ax, dy = by - ay;
  return dx * dx + dy * dy;
}
export function dist(ax, ay, bx, by) {
  return Math.sqrt(dist2(ax, ay, bx, by));
}
export function len(x, y) { return Math.sqrt(x * x + y * y); }

// Returns a normalized vector as [x, y]; zero vector stays zero.
export function norm(x, y) {
  const l = Math.sqrt(x * x + y * y);
  if (l < 1e-6) return [0, 0];
  return [x / l, y / l];
}

export const angleOf = (dx, dy) => Math.atan2(dy, dx);

export function fromAngle(a, mag = 1) {
  return [Math.cos(a) * mag, Math.sin(a) * mag];
}

// Shortest signed angular difference b - a in (-PI, PI].
export function angleDiff(a, b) {
  let d = (b - a) % TAU;
  if (d > Math.PI) d -= TAU;
  if (d < -Math.PI) d += TAU;
  return d;
}

// Move current angle toward target by at most maxStep radians.
export function approachAngle(current, target, maxStep) {
  const d = angleDiff(current, target);
  if (Math.abs(d) <= maxStep) return target;
  return current + Math.sign(d) * maxStep;
}

// Move value toward target by at most maxStep.
export function approach(current, target, maxStep) {
  if (current < target) return Math.min(current + maxStep, target);
  return Math.max(current - maxStep, target);
}

export function smoothstep(t) {
  t = clamp01(t);
  return t * t * (3 - 2 * t);
}

// Deterministic 2D integer hash -> float in [0,1). Used for endless decoration.
export function hash2(ix, iy, seed = 0) {
  let h = (ix | 0) * 374761393 + (iy | 0) * 668265263 + (seed | 0) * 2246822519;
  h = (h ^ (h >>> 13)) >>> 0;
  h = (h * 1274126177) >>> 0;
  h = (h ^ (h >>> 16)) >>> 0;
  return h / 4294967296;
}

export const deg = (r) => (r * 180) / Math.PI;
export const rad = (d) => (d * Math.PI) / 180;
